<template>
  <button class="btn" @click="onClick">
    {{ text }}
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
  height: 48px;
  padding: 16px;
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.1;
  cursor: pointer;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  color: $white;
  border-radius: 100px;

  %disabled-common {
    background-color: $gray-2;
    color: $gray-1;
  }

  &:disabled {
    @extend %disabled-common;
    cursor: default;
    border: 0;
  }

  &[disabled]:hover {
    @extend %disabled-common;
    opacity: 100%;
  }

  @media (hover: hover) {
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
